import {useEffect, useState} from 'react'
import fieldConfig from '../../../../configs/askGivePrismFieldConfig.json'
import CustomSearchableDropdown from '../../../Common/CustomSearchableDropdown'
import CustomDatePicker from '../../../Common/CustomDatePicker'
import {useDispatch, useSelector} from 'react-redux'
import {mapDropdownOptions} from '../../../../helper/commonHelper'
import {Controller, useForm} from 'react-hook-form'
import dayjs from 'dayjs'
import {
  setCurrentSelectedFilter,
  setFilters,
  setSearchQuery,
  setSearchTermQuery,
  setUniqueConstituentIdentifier
} from '../../../../store/askGivePrism/askGivePrismSlice'
import {
  StyledBox,
  StyledFieldContainer,
  StyledField,
  StyledLabel,
  StyledValueBox,
  StyledActionButtons,
  StyledClearButton,
  StyledCreateSegmentedListButton,
  StyledSpan,
  StyledContainer,
  StyledButton,
  StyledInterestTagTitleContainer,
  StyledActionResetButton,
  StyledActionAddButton
} from '../Styles'
import {
  getAllProspectsData,
  setSelectedOppurtunity,
  setSortColumn,
  setSortConfig,
  setSortDirection
} from '../../../../store/prospectSegment/allProspectsData/allProspectsDataSlice'
import {getProspectsPageNumber} from '../../../../store/pagination/pageNumberSlice'
import {selectedTab} from '../../../../store/prospectSegment/selectedProspectsTab/selectedProspectsTabSlice'
import {constituentIdList} from '../../../../store/prospectSegment/savedProspectsList/saveProspectsListSlice'
import CategoryBasedInterestTagPopup from '../CategoryBasedInterestTagPopup/CategoryBasedInterestTagPopupIndex'
import CustomDialog from '../../../Common/CustomDialog'
import {StyledActionBox} from '../../../Common/Styles'
import {
  setAppliedInterestTags,
  setCategoryTagName,
  setRemoveSpecificCategoryTagRefData,
  setSearchedInterestTag,
  setSelectedInterestOptions,
  setTotalInterestTagCount
} from '../../../../store/askGivePrism/categorizedInterestTagSlice'
import paginationLimit from '../../../../configs/paginationLimit.json'
import {StyledManualBoxContainer, StyledManualPaperContainer} from './AskGPViewsStyles'
import {Grid} from '@mui/material'
import CustomChip from '../../../Common/CustomChip/CustomChipIndex'
import {setResetSearchTerm, updatedAllProspectsSearchTerm} from '../../../../store/search/searchSlice'

const defaultValues = {
  city: [],
  givingCapacity: [],
  classYear: [],
  lastContactDate: null,
  prospectType: [],
  tagId: [],
  likelihoodToGive: [],
  boardMember: null,
  degree: [],
  college: [],
  currentIndustry: [],
  state: []
}

const ManualFiltersView = () => {
  const dispatch = useDispatch()
  const [fields, setFields] = useState(fieldConfig.fields)
  const [options, setOptions] = useState({})
  const refData = useSelector((state) => state.opportunityBank.refData)
  const isRefDataLoading = useSelector((state) => state.opportunityBank.isRefDataLoading)
  const {control, reset, handleSubmit} = useForm({
    defaultValues
  })
  const askGivePrismFilters = useSelector((state) => state.askGivePrism.filters)

  const searchQueryTerm = useSelector((state) => state.askGivePrism.searchTerm)
  const uniqueConstituentIdentifierList = useSelector((state) => state.askGivePrism.uniqueConstantIdentifier)
  const [submitButton, setSubmitButton] = useState('Create segmented list')
  const [defaultFilterText, setDefaultFilterText] = useState(true)
  const [categoryInterestTagOpen, setCategoryInterestTagOpen] = useState(false)
  const categorisedInterestTagRefData = useSelector(
    (state) => state.categorizedInterestTag.categorisedInterestTagRefData
  )
  const isCategorizedInterestRefDataLoading = useSelector(
    (state) => state.categorizedInterestTag.isCategorizedInterestRefDataLoading
  )
  const isCategorizedInterestRefDataError = useSelector(
    (state) => state.categorizedInterestTag.isCategorizedInterestRefDataError
  )
  const interestTagSearchTerm = useSelector((state) => state.categorizedInterestTag.searchedInterestTag)

  const selectedInterestOptions = useSelector((state) => state.categorizedInterestTag.selectedInterestOptions)
  const appliedInterestTags = useSelector((state) => state.categorizedInterestTag.appliedInterestTags)
  const azureRole = useSelector((state) => state.superUserTenantSlice.azureRole)

  const currentSelectedFilter = useSelector((state) => state.askGivePrism.currentSelectedFilter)

  useEffect(() => {
    dispatch(setFilters({}))
    const newFields = fields?.map((obj) => {
      obj.show = obj.isDefault
      return obj
    })
    setFields(newFields)
    dispatch(setSearchTermQuery({previousTerm: '', currentTerm: ''}))
    dispatch(setSearchQuery(''))

    dispatch(setUniqueConstituentIdentifier([]))
    dispatch(setAppliedInterestTags([]))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, azureRole])

  useEffect(() => {
    if (refData && refData.length > 0) {
      const options = buildAllOptions(refData, fields)
      setOptions(options)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refData, fields])

  // Helper function to build all options from refData
  const buildAllOptions = (refData, fields) => {
    const options = {}
    for (const field of fields) {
      options[field.fieldId] = buildFieldOptions(field, refData)
    }
    return options
  }

  // Helper function to build options for a single field
  const buildFieldOptions = (field, refData) => {
    const response = refData.find((obj) => obj.filter === field.optionsFieldId)
    const responseValues = getResponseValues(response)
    return mapDropdownOptions(responseValues)
  }

  // Helper function to extract response values from refData
  const getResponseValues = (response) => {
    if (!response) return []

    if (response.values?.length) return response.values
    if (response.valuesInt?.length) return response.valuesInt
    if (response.valuesWithId?.length) return response.valuesWithId

    return []
  }

  const [updatedCategorizedInterestRefData, setUpdatedCategorizedInterestRefData] =
    useState(categorisedInterestTagRefData)

  useEffect(() => {
    if (
      categorisedInterestTagRefData?.length > 0 &&
      !isCategorizedInterestRefDataError &&
      !isCategorizedInterestRefDataLoading
    ) {
      const modifiedCategorisedInterestTag = structuredClone(categorisedInterestTagRefData)
      modifiedCategorisedInterestTag.map((item) => {
        return item.interestTagList.map((tag) => {
          tag.selected = false
          return tag
        })
      })
      setUpdatedCategorizedInterestRefData(modifiedCategorisedInterestTag)
    }
  }, [categorisedInterestTagRefData, isCategorizedInterestRefDataError, isCategorizedInterestRefDataLoading])

  const handleClear = () => {
    reset()
    const newFields = fields?.map((obj) => {
      obj.show = obj.isDefault
      return obj
    })
    setFields(newFields)
    dispatch(setFilters({}))
    dispatch(selectedTab('allProspects'))
    if (Object.keys(askGivePrismFilters).length > 0) {
      dispatch(getAllProspectsData([]))
      dispatch(getProspectsPageNumber(1))
    }
    dispatch(setSelectedOppurtunity([]))
    dispatch(constituentIdList([]))
    dispatch(setSearchTermQuery({previousTerm: '', currentTerm: ''}))
    dispatch(setSearchQuery(''))
    dispatch(setUniqueConstituentIdentifier([]))
    setSubmitButton('Create segmented list')
    setDefaultFilterText(true)
    dispatch(setAppliedInterestTags([]))
    dispatch(setCurrentSelectedFilter({}))
    dispatch(updatedAllProspectsSearchTerm({currentTerm: '', previousTerm: ''})) // reset all prospects search term
    dispatch(setResetSearchTerm(true))
    dispatch(setSortColumn(null))
    dispatch(setSortDirection('asc'))
    dispatch(setSortConfig({direction: 'asc', key: null}))
  }

  const handleCreateSegmentedList = (formData) => {
    const filters = {}
    let fieldConfig = {}
    for (const key of Object.keys(formData)) {
      fieldConfig = fields.find((obj) => obj.fieldId === key)
      if (formData[key]) {
        if (fieldConfig.fieldType === 'single-select' && Object.keys(formData[key]).length > 0) {
          filters[key] = formData[key]?.id
        } else if (fieldConfig.fieldType === 'multi-select' && formData[key].length > 0) {
          filters[key] = formData[key].map((obj) => obj.id)
        } else if (fieldConfig.fieldType === 'date') {
          filters[key] = dayjs(formData[key]).format('YYYY-MM-DD')
        }
      }
    }
    if (filters?.boardMember != null) {
      filters.boardMember = filters.boardMember === 'Yes'
    }
    if (appliedInterestTags?.length > 0) {
      filters.tagId = appliedInterestTags.map((tag) => tag.id)
    }
    if (Object.keys(filters).length === 0) {
      handleClear()
    } else if (Object.keys(filters).length !== 0 && searchQueryTerm) {
      filters.uniqueConstituentIdentifier = uniqueConstituentIdentifierList
    }
    dispatch(setFilters(filters))
    dispatch(selectedTab('allProspects'))
    dispatch(setSelectedOppurtunity([]))
    dispatch(constituentIdList([]))
    dispatch(getAllProspectsData([]))
    dispatch(setSearchTermQuery({previousTerm: '', currentTerm: ''}))
    dispatch(setSearchQuery(''))
    dispatch(updatedAllProspectsSearchTerm({currentTerm: '', previousTerm: ''})) // reset all prospects search term
    dispatch(setResetSearchTerm(true))

    dispatch(setSortColumn(null))
    dispatch(setSortDirection('asc'))
    dispatch(setSortConfig({direction: 'asc', key: null}))
  }

  const handleAllInterestTag = () => {
    dispatch(setSelectedInterestOptions(appliedInterestTags))
    setCategoryInterestTagOpen(true)
  }

  const handleClose = () => {
    setCategoryInterestTagOpen(false)
    dispatch(setCategoryTagName(''))
    if (interestTagSearchTerm) {
      dispatch(setRemoveSpecificCategoryTagRefData())
      dispatch(setSearchedInterestTag(''))
    }
    dispatch(setTotalInterestTagCount(paginationLimit.pagination.cateogryInterestTagLimt))
  }

  const handleModalClose = (event, reason) => {
    if (reason && reason === 'backdropClick') return
    handleClose()
  }

  const handleResetTags = () => {
    const modifiedCategorisedInterestTag = structuredClone(updatedCategorizedInterestRefData)
    modifiedCategorisedInterestTag?.map((item) => {
      return item.interestTagList.map((tag) => {
        tag.selected = false
        return tag
      })
    })
    setUpdatedCategorizedInterestRefData(modifiedCategorisedInterestTag)
    if (interestTagSearchTerm) {
      dispatch(setRemoveSpecificCategoryTagRefData())
      dispatch(setSearchedInterestTag(''))
      dispatch(setCategoryTagName(''))
    }
    dispatch(setSelectedInterestOptions([]))
  }

  const handleApplyTags = () => {
    dispatch(setAppliedInterestTags(selectedInterestOptions))
    setCategoryInterestTagOpen(false)
    dispatch(setCategoryTagName(''))
    dispatch(setTotalInterestTagCount(paginationLimit.pagination.cateogryInterestTagLimt))
    if (interestTagSearchTerm) {
      dispatch(setRemoveSpecificCategoryTagRefData())
      dispatch(setSearchedInterestTag(''))
    }
  }

  const handleSelectedTags = (checked, selectedInterestTagsOptions, categoryName, interestTagId, interestName) => {
    if (checked) {
      dispatch(
        setSelectedInterestOptions(
          selectedInterestTagsOptions.filter((item) => !(item.id === interestTagId && item.category === categoryName))
        )
      )
    } else {
      dispatch(
        setSelectedInterestOptions([
          ...selectedInterestTagsOptions,
          {category: categoryName, id: interestTagId, name: interestName}
        ])
      )
    }
  }

  const handleCurrentSelectedFilters = (field, selectedValue) => {
    const updatedFilters = {
      ...currentSelectedFilter, // Spread the existing filters
      [field.fieldId]: selectedValue // Update the current dropdown value
    }

    const nonEmptyFilters = Object.fromEntries(
      Object.entries(updatedFilters).filter(([key, value]) => {
        if (Array.isArray(value)) {
          return value.length > 0 // Keep non-empty arrays
        }
        return value !== null && value !== '' // Keep non-null and non-empty values
      })
    )

    return nonEmptyFilters
  }

  return (
    <StyledManualBoxContainer>
      <form onSubmit={handleSubmit(handleCreateSegmentedList)}>
        <StyledManualPaperContainer>
          <StyledFieldContainer>
            <StyledBox>
              <StyledSpan defaultFilterText={defaultFilterText}>Manual Filters</StyledSpan>
            </StyledBox>
            <Grid container spacing={2}>
              {fields?.map((field) => {
                return (
                  field.show && (
                    <Grid item xs={12} sm={6} key={field.fieldName}>
                      <StyledContainer>
                        <StyledField>
                          <StyledLabel>{field.fieldName}</StyledLabel>
                          <StyledValueBox>
                            {(field.fieldType === 'single-select' || field.fieldType === 'multi-select') && (
                              <Controller
                                name={field.fieldId}
                                control={control}
                                render={({field: {onChange, value}}) => (
                                  <CustomSearchableDropdown
                                    options={
                                      field.fieldId === 'givingCapacity'
                                        ? options[field.fieldId]?.sort((a, b) =>
                                            a.name.localeCompare(b.name, undefined, {numeric: true})
                                          )
                                        : options[field.fieldId]
                                    }
                                    isMultiSelect={field.fieldType === 'multi-select'}
                                    loading={isRefDataLoading}
                                    onChange={(selectedValue) => {
                                      const nonEmptyFilters = handleCurrentSelectedFilters(field, selectedValue)
                                      // Dispatch the updated filters to the Redux store
                                      dispatch(setCurrentSelectedFilter(nonEmptyFilters))
                                      // Call the original onChange handler to update the form state
                                      onChange(selectedValue)
                                    }}
                                    value={value}
                                    fieldName={field.fieldId}
                                  />
                                )}
                              />
                            )}
                            {field.fieldType === 'date' && (
                              <Controller
                                name={field.fieldId}
                                control={control}
                                render={({field: {onChange, value}}) => (
                                  <CustomDatePicker
                                    value={value ? dayjs(value) : null}
                                    onChange={(selectedValue) => {
                                      const nonEmptyFilters = handleCurrentSelectedFilters(field, selectedValue)
                                      // Dispatch the updated filters to the Redux store
                                      dispatch(setCurrentSelectedFilter(nonEmptyFilters))
                                      // Call the original onChange handler to update the form state
                                      onChange(selectedValue)
                                    }}
                                  />
                                )}
                              />
                            )}

                            {field.fieldType === 'input' && (
                              <Controller
                                name={field.fieldId}
                                control={control}
                                render={() => (
                                  <>
                                    <CustomChip chipData={appliedInterestTags} />
                                    <StyledButton
                                      applyMargin={appliedInterestTags.length > 0}
                                      onClick={handleAllInterestTag}
                                    >
                                      + Add interest tags
                                    </StyledButton>
                                  </>
                                )}
                              />
                            )}
                          </StyledValueBox>
                        </StyledField>
                      </StyledContainer>
                    </Grid>
                  )
                )
              })}
            </Grid>
          </StyledFieldContainer>
          <StyledActionButtons>
            <StyledClearButton onClick={handleClear}>Clear</StyledClearButton>
            <StyledCreateSegmentedListButton type="submit">{submitButton}</StyledCreateSegmentedListButton>
          </StyledActionButtons>
        </StyledManualPaperContainer>
      </form>

      {categoryInterestTagOpen && (
        <CustomDialog
          open={categoryInterestTagOpen}
          showDivider={false}
          maxWidth="md"
          categorizeInterestTags={true}
          title={<StyledInterestTagTitleContainer>Search all interest tags</StyledInterestTagTitleContainer>}
          handleClose={handleModalClose}
          content={
            <CategoryBasedInterestTagPopup
              interestTagRefData={updatedCategorizedInterestRefData}
              isInterestTagRefDataLoading={isCategorizedInterestRefDataLoading}
              isInterestTagRefDataLoadingError={isCategorizedInterestRefDataError}
              selectedInterestOptions={selectedInterestOptions}
              handleSelectedTags={handleSelectedTags}
            />
          }
          actions={
            <StyledActionBox>
              <StyledActionResetButton onClick={handleResetTags}>Reset tags</StyledActionResetButton>
              <StyledActionAddButton onClick={handleApplyTags}>Apply tags</StyledActionAddButton>
            </StyledActionBox>
          }
        />
      )}
    </StyledManualBoxContainer>
  )
}

export default ManualFiltersView
